import Vue from 'vue'
import { IMaskDirective } from 'vue-imask'

Vue.directive('mask', IMaskDirective)
